import axios from 'axios'

import { getTokenForGraph } from '@/services/auth/auth.service'

const axiosInstance = axios.create({
  baseURL: 'https://graph.microsoft.com/v1.0/',
})

export async function getSites(search) {
  try {
    const token = await getTokenForGraph()
    const headers = { Authorization: `Bearer ${token.accessToken}` }
    const options = { headers }

    const req = await axiosInstance.get(`/sites?search=${search}`, options)

    if (req.status === 200) {
      return req.data
    } else {
      throw new Error(req.statusText)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getSite(siteId) {
  try {
    const token = await getTokenForGraph()
    const headers = { Authorization: `Bearer ${token.accessToken}` }
    const options = { headers }

    const req = await axiosInstance.get(`/sites/${siteId}`, options)

    if (req.status === 200) {
      return req.data
    } else {
      throw new Error(req.statusText)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getLists(siteId) {
  try {
    const token = await getTokenForGraph()
    const headers = { Authorization: `Bearer ${token.accessToken}` }
    const options = { headers }

    const req = await axiosInstance.get(`/sites/${siteId}/lists`, options)

    if (req.status === 200) {
      return req.data
    } else {
      throw new Error(req.statusText)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getList(siteId, listId) {
  try {
    const token = await getTokenForGraph()
    const headers = { Authorization: `Bearer ${token.accessToken}` }
    const options = { headers }

    const req = await axiosInstance.get(
      `/sites/${siteId}/lists/${listId}`,
      options
    )

    if (req.status === 200) {
      return req.data
    } else {
      throw new Error(req.statusText)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function postListItems(siteId, listId, items) {
  try {
    const token = await getTokenForGraph()
    const headers = { Authorization: `Bearer ${token.accessToken}` }
    const options = { headers }

    const requests = []
    items.forEach((item) => {
      requests.push(
        axiosInstance.post(
          `/sites/${siteId}/lists/${listId}/items`,
          item,
          options
        )
      )
    })

    const values = await Promise.all(requests)
    return values
  } catch (error) {
    throw new Error(error)
  }
}
